export default "__VITE_ASSET__1a17bc85__"